module.exports = __webpack_public_path__ + "img/3.871c6dd4.jpg";